import { Component } from "@angular/core";

import { SvgMixinLargeComponent } from "../svg-large-mixin.component";

@Component({
  selector: "med-icon-comments",
  templateUrl: "./med-icon-comments.component.html",
})
export class MedIconCommentsComponent extends SvgMixinLargeComponent { }
